import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);

    // (re)run scroll-reveal after route content mounts
    const t = setTimeout(() => {
      const els = document.querySelectorAll(".reveal:not(.in)");
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      els.forEach((el) => io.observe(el));
      // fallback: never leave content invisible if observer doesn't fire
      setTimeout(() => {
        document.querySelectorAll(".reveal:not(.in)").forEach((el) => el.classList.add("in"));
      }, 1600);
    }, 60);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
